// We want to Check the URL and search for any Parameters that equal 'affiliate'
// if true - set localStorage with that Affiliate ID value
// if a user visits a form (Application form, Contact Us form, Rental Enquiry form) populate an hidden field
// If an exisiting Affiliate ID is saved, and a new ID has been recorded we need to update / overwrite existing

const AffiliateProgram = function() {
  //---- Variables ----//
  const localStorage = window.localStorage
  let formsIds = [
    `sc-contact-form`,
    `sc-application-form`,
    `rental-form`,
    `rental-form-stepped`
  ]
  let storedAffiliateID = localStorage.getItem(`affiliate-id`)
  let aCookieIsSet = false

  //---- Init Actions ----//
  function init() {
    if (formsIds.some(checkIfFormExists)) {
      if (
        localStorage.getItem(`affiliate-id`) === null ||
        localStorage.getItem(`affiliate-id`) === undefined
      ) {
        //-- Abort
        return false
      } else {
        //-- Populate Hidden Field
        //-- If the Quick Enquiry Rental Form Exists, use salesforce Affiliate ID
        //-- Else, use the default 'affiliate-id' name attribute
        const collectionAndPDPForm = document.querySelector(`#rental-form`)
        if (collectionAndPDPForm) {
          populateHiddenAffiliateField(
            `input[name='00N0K00000L08PY']`,
            getAffiliateID()
          )
        } else {
          populateHiddenAffiliateField(
            `input[name='affiliate-id']`,
            getAffiliateID()
          )
        }
      }
    }
  }

  //----------- URL Parameter Actions -----------//
  const checkWhetherTheURLcontainsParams = param => {
    //-- Using the Search method within the Location Object
    //-- We can return the '?' and everything after it.
    let url = window.location.search.substr(1)
    let searchParams = parse_query_string(url)

    //-- Check if Parameter Exists
    if (searchParams !== null && searchParams.affiliate) {
      let affiliateParamValue = searchParams.affiliate

      //-- Contains param > BUT no Cookie is Set
      if (
        localStorage.getItem(`affiliate-id`) === null ||
        localStorage.getItem(`affiliate-id`) === undefined
      ) {
        setAffiliateIDwithExpiry(affiliateParamValue, 30)
        aCookieIsSet = true
      }
      //-- Contains param > AND a Cookie is Set
      else {
        //-- Contains param > MATCHES Cookie
        if (affiliateParamValue == getAffiliateID()) {
          // Abort
          aCookieIsSet = true
          return
        }
        //-- Contains param > UPDATE Cookie
        else {
          setAffiliateIDwithExpiry(affiliateParamValue, 30)
          aCookieIsSet = true
        }
      }
    }
    //-- No Parameter within the URL
    else {
      //-- No param...
      if (
        localStorage.getItem(`affiliate-id`) === null ||
        localStorage.getItem(`affiliate-id`) === undefined
      ) {
        //-- No param & No Cookie > Abort
        return
      } else {
        //-- No param > BUT a Cookie is already Set
        aCookieIsSet = true
      }
    }
  }

  //-- using these function due to the fact URLSearchParams is not supported in IE
  function parse_query_string(query) {
    let vars = query.split(`&`)
    let query_string = {}
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split(`=`)
      let key = decodeURIComponent(pair[0])
      let value = decodeURIComponent(pair[1])
      // If first entry with this name
      if (typeof query_string[key] === `undefined`) {
        query_string[key] = decodeURIComponent(value)
        // If second entry with this name
      } else if (typeof query_string[key] === `string`) {
        let arr = [query_string[key], decodeURIComponent(value)]
        query_string[key] = arr
        // If third or later entry with this name
      } else {
        query_string[key].push(decodeURIComponent(value))
      }
    }
    return query_string
  }

  //----------- Form Actions ----------- //
  const populateHiddenAffiliateField = (selector, affiliateId) => {
    const affiliateField = document.querySelector(selector)

    if ((affiliateField && affiliateId != undefined) || affiliateId != null) {
      affiliateField.setAttribute(`value`, affiliateId)
    }
  }

  const checkIfFormExists = element => {
    let elementExists = document.getElementById(element)
    return elementExists
  }

  //----------- Local Storage Actions ----------- //
  const setAffiliateIDwithExpiry = (affiliateID, daysUntilExpire) => {
    const now = new Date()
    let affiliateData = {
      id: affiliateID,
      //-- Convert the Days Until Expiry to a timestamp.
      //-- Source: https://stackoverflow.com/questions/22734166/what-is-the-meaning-of-using-days2460601000-in-cookie
      expiry: now.getTime() + daysUntilExpire * 24 * 60 * 60 * 1000
    }

    //-- If 'storedAffiliateID' doesn't Exists - set affiliate-id
    if (!storedAffiliateID) {
      localStorage.setItem(`affiliate-id`, JSON.stringify(affiliateData))
    } else {
      //-- Check if the affiliateID matches matches storedAffiliateID in localStorage
      //-- If it does continue, else update the affiliateID
      if (affiliateID !== storedAffiliateID) {
        localStorage.setItem(`affiliate-id`, JSON.stringify(affiliateData))
      } else {
        return
      }
    }
  }

  const getAffiliateID = () => {
    const affiliateData = JSON.parse(localStorage.getItem(`affiliate-id`))
    const now = new Date()
    const then = new Date(affiliateData.expiry)
    let pastExpiry = now.getTime() > then.getTime()

    //-- compare the expiry time of the item with the current time
    if (pastExpiry) {
      //-- If the item is expired, delete the item from storage and return null
      localStorage.removeItem(`affiliate-id`)
      return null
    }
    return affiliateData.id
  }

  //----------- Execute Functions ----------- //
  checkWhetherTheURLcontainsParams(`affiliate`)
  document.addEventListener(`DOMContentLoaded`, () => {
    if (aCookieIsSet) {
      setTimeout(() => {
        init()
      }, 500)
    }
  })
}

export default AffiliateProgram
